<template>
    <b-container v-if="load.Loading" class="container-basic-spinner">
        <spinner />
    </b-container>
    <div v-else>

        <b-row class="m-0 categories-row-button">

            <transition name="visibility-switch">

                <b-col v-if="isSortingUpdated" class="h-end p-0 mr-10">
                    <b-button id="admin-btn-save"
                              class="admin-button mr-10"
                              @click="saveSorting">
                        Сохранить
                    </b-button>

                    <b-button id="admin-btn-cancel"
                            class="m-0 admin-button"
                            @click="cancelSorting">
                        Отменить
                    </b-button>
                </b-col>
                
            </transition>

            <b-button id="admin-btn-add"                                                
                      class="admin-button" 
                      @click="moveToEdit">
                Добавить
            </b-button>           

        </b-row> 

        <hr />

        <div>
            <b-row class="m-0 categories-head">
                <b-col cols="8" class="v-center">
                    Наименование
                </b-col>

                <b-col class="p-0 v-center">
                    Статус
                </b-col>
            </b-row>            
        </div>

        <hr />

        <draggable v-model="taskCategories"
                   v-bind="{handle:'.handle', animation:300}"
                   @input="isSortingUpdated = true">  

            <div class="p-0"
                 v-for="(item, index) in taskCategories"
                 :key="index">

                <b-row class="m-0 categories-content">

                    <b-col cols="8" class="v-center">

                        <a :href="`/Admin/TodoCategories/Edit?id=${item.Id}`" 
                           class="custom-table-list-link">

                            {{item.Name}}
                        </a>
                    </b-col>

                    <b-col class="v-center">
                        {{item.IsActive}}
                    </b-col>

                    <b-col cols="1" class="sort-handle handle"/>

                </b-row>

                <hr />
            </div>

        </draggable>   

    </div>
</template>
<script>
import AllRoutes from '@/routes/all.routes'

import apiService from '@/services/api.service'
import dialogService from '@/services/dialog.service'

import Loading from '@/store/models/Loading'
import Spinner from '@/components/shared/Spinner'

export default {
    beforeRouteLeave: function(to, from, next) {
        if(this.isSortingUpdated) {            
            dialogService.showConfirm('Предупреждение', 'У Вас есть несохраненные изменения. Для сохранения изменений и перехода на следующий экран нажмите "Продолжить". Для отмены сохранений и перехода на следующий экран нажмите "Отмена"')
                .then(ok => { 
                    this.saveSorting() 
                    next();
                })
                .catch(cancel => { 
                    this.cancelSorting();
                    next();
                });
        }
        else {
            next();          
        }        
    },
    created: function() {
        let vm = this;
        window.addEventListener('beforeunload', function (e) {
            vm.show(e);
        });
    },
    destroyed: function() {
        let vm = this;
        window.removeEventListener('beforeunload', function (e) {
            vm.show(e);         
        });
    },
    data: function() {

        let load = new Loading();
        
        this.getTodoCategories(load);

        return {
            load: load,
            taskCategories: null,
            taskCategoriesCopy: null,

            isSortingUpdated: false
        }
    },
    methods: {
        show: function(e) {
            if(this.isSortingUpdated) {     
                e.preventDefault(); 
                e.returnValue = '';
            }
        },
        getTodoCategories: function(load) {
            load.Calculate(true);

            apiService.Admin.TodoCategories.GetAll()
                .then(response => {
                    this.taskCategories = response.data;
                    this.taskCategories.map(e => e.IsActive ? e.IsActive = 'Активный' : e.IsActive = 'Неактивный');
                    this.taskCategoriesCopy = JSON.parse(JSON.stringify(response.data));
                    load.Calculate(false);
                })
                .catch(error => load.Calculate(false));
        },

        cancelSorting: function() {
            this.isSortingUpdated = false;
            this.taskCategories = JSON.parse(JSON.stringify(this.taskCategoriesCopy));
        },

        saveSorting: function() {        
            this.taskCategoriesCopy = JSON.parse(JSON.stringify(this.taskCategories));

            this.load.Calculate(true)
            let taskCategoriesId = this.taskCategories.map(e => e.Id);

            apiService.Admin.TodoCategories.PostUpdateSorting(taskCategoriesId)
                .then(response => {
                    this.isSortingUpdated = false;
                    this.taskCategoriesCopy = JSON.parse(JSON.stringify(this.taskCategories));
                    this.load.Calculate(false);
                })
                .catch(error => this.load.Calculate(false));
        },

        moveToEdit: function() {
            this.$router.push(AllRoutes.Admin.TodoCategories.Edit);
        }
    },
    components: {
        Spinner
    }
}
</script>

<style>
.categories-row-button {
    margin-bottom: 13px !important;     
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.categories-head {
    font-size: 15px;
    font-family: 'HelveticaNeueCyr-Bold';
    color: #222;
}

.categories-content {
    padding-right: 15px; 
    font-family: 'HelveticaNeueCyr-Roman';
    letter-spacing: .5px;
    font-size: 17px;
}
</style>